import { useCallback, useEffect, useState } from "react";
import { useSettingsApi } from "../api/settingsApi";

export function useSettings() {
  const api = useSettingsApi();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAll();
      setSettings(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const updateSettings = async (data) => {
    const saved = await api.update(data);

    setSettings(saved);
  };

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return {
    settings,
    loading,
    error,
    fetchSettings,
    updateSettings,
  };
}
